import React from 'react';

const SteamValuation = React.lazy(() => import("./SteamValuation"));

export const steamRouteConfig = [
    {
        path: '/steam-valuation',
        element: <SteamValuation/>
    }
];